import { slice as appSlice } from '../../slices/app'
import store from '@polleverywhere/redux'

/**
 * Capacitor specific concern coordination
 */
export default async (app) => {
  if (!window.Capacitor?.isNative) {
    return
  }

  const { role } = store.getState()[appSlice.name]

  // iOS presenter apps do not allow signup
  const isIos = window.Capacitor?.platform === 'ios'
  const presenterRole = role === 'presenter'

  const optionOverrides = {
    allowSignups: !(isIos && presenterRole),

    // Capacitor apps cannot redirect the container to other sites
    allowRedirects: false,

    // Force debug mode when in capacitor debug environment
    debug: window.Capacitor?.DEBUG
  }

  store.dispatch(appSlice.optionsUpdated(optionOverrides))

  // Dyanmically load the chunks
  const {
    ExternalScreenDispatcher,
    StatusBarDispatcher,
    FirebaseDispatcher,
    DeepLinking,
    SplashScreen,
    Rollbar,
    InAppPurchase,
    BackButton
  } = await import(/* webpackChunkName: 'capacitor-dispatchers-chunk' */ './chunk')

  ExternalScreenDispatcher(app)
  StatusBarDispatcher(app)
  FirebaseDispatcher(app)
  DeepLinking(app)
  SplashScreen(app)
  Rollbar(app)
  InAppPurchase(app)
  BackButton(app)
}
